import { useMutation } from '@tanstack/react-query';
import { useGetMerchant } from '@repo/api/endpoints/merchant';
import { ApiClient, apiPaths, useApiErrorStoreActions } from '@repo/api/client';
import { loanCancelSuccessResponse } from './loan-cancel.schema';
var apiEndpoint = apiPaths.loan.cancel;
function patchLoanCancel(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'PATCH', body: JSON.stringify(payload) },
        successSchema: loanCancelSuccessResponse,
    });
}
export function usePatchLoanCancel(_a) {
    var hash = _a.hash, token = _a.token;
    var refetch = useGetMerchant({ hash: hash, token: token, enabled: false, skipDelay: true }).refetch;
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: patchLoanCancel,
        onError: function (error) {
            void refetch();
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
